import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { UnauthorizedPage } from '../../unauthorized/unauthorized';
import { ErrorPage } from '../../error/error';
import { NotFoundPage } from '../../notFound/notFound';

export interface EmptyLayoutProps {
  logoutHandler: () => void;
  email: string;
}

export const EmptyLayout: React.FC<EmptyLayoutProps> = props => {
  return (
    <>
      <Switch>
        <Route
          path="/error/500"
          render={() => (
            <ErrorPage logoutHandler={props.logoutHandler} email={props.email} />
          )}
        />
        <Route
          path="/error/401"
          render={() => (
            <UnauthorizedPage logoutHandler={props.logoutHandler} email={props.email} />
          )}
        />
        <Route
          path="/error/404"
          render={() => (
            <NotFoundPage logoutHandler={props.logoutHandler} email={props.email} />
          )}
        />
        <Route component={ErrorPage} />
      </Switch>
    </>
  );
};
